import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "./api";

const AuthCtx = createContext(null);

const lockOf = (e) => {
  const d = e?.response?.data?.detail;
  return e?.response?.status === 403 && d?.code === "account_locked" ? d : null;
};

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [locked, setLocked] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const res = await api.get("/auth/me");
      setUser(res.data);
    } catch (e) {
      const l = lockOf(e);
      if (l) setLocked(l);
      setUser(null);
    }
  }, []);

  useEffect(() => {
    // Any API call that reports a locked account switches the app to the lock screen.
    const id = api.interceptors.response.use(r => r, (e) => {
      const l = lockOf(e);
      if (l) { setLocked(l); setUser(null); }
      return Promise.reject(e);
    });
    return () => api.interceptors.response.eject(id);
  }, []);

  useEffect(() => {
    // Skip /me if returning from OAuth - AuthCallback handles it
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    refresh().finally(() => setLoading(false));
  }, [refresh]);

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    setUser(null);
    window.location.href = "/";
  };

  return (
    <AuthCtx.Provider value={{ user, setUser, loading, refresh, logout, locked, setLocked }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
